module.exports = __webpack_public_path__ + "img/9.18866b83.webp";